module.exports = __webpack_public_path__ + "static/media/BalancoFinanc2.7ee4a82e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelBalancoFinanc/BalancoFinanc2.png
// module id = 2172
// module chunks = 0